import { Controller } from "@hotwired/stimulus"

const HIDDEN_ICON_CLASS = "fa-eye"
const REVEALED_ICON_CLASS = "fa-eye-slash"

export default class extends Controller {
  static targets = ["input", "icon"]

  toggle({ currentTarget }) {
    const reveal = this.inputTarget.type === "password"

    this.inputTarget.type = reveal ? "text" : "password"
    this.iconTarget.classList.toggle(REVEALED_ICON_CLASS, reveal)
    this.iconTarget.classList.toggle(HIDDEN_ICON_CLASS, !reveal)
    currentTarget.setAttribute("aria-pressed", reveal)
    this.inputTarget.focus()
  }
}
